/**
 * Cascade plans: each source maps to an ordered list of steps.
 *
 * A step is either a StepId string, or { step, meta } when that step needs config
 * (mode, apply keys, search flags, syncNav, etc.).
 */

/** @typedef {'collegeOptions'|'termOptions'|'resetCourse'|'courses'|'search'|'searchPage'} StepId */

/**
 * @typedef {import('@/types').PhaseMeta} PhaseMeta
 */

/**
 * @typedef {StepId | { step: StepId, meta?: PhaseMeta }} PlanStep
 */

/**
 * @typedef {Object} FilterPlan
 * @property {PlanStep[]} steps
 * @property {PhaseMeta} [meta]
 */

/** @type {Record<string, FilterPlan>} */
export const FILTER_GRAPH = {
	init: {
		steps: [
			'collegeOptions',
			{ step: 'termOptions', meta: { mode: 'initial' } },
			{ step: 'search', meta: { search: { initial: true }, syncNav: 'assign' } },
		],
	},

	college: {
		steps: [
			'collegeOptions',
			{ step: 'termOptions', meta: { mode: 'update' } },
			'resetCourse',
			{ step: 'search', meta: { search: { update: true }, syncNav: 'spread' } },
		],
	},

	term: {
		steps: [
			{ step: 'termOptions', meta: { mode: 'update' } },
			'resetCourse',
			{ step: 'search', meta: { search: { update: true }, syncNav: 'spread' } },
		],
	},

	campus: {
		steps: [
			{ step: 'termOptions', meta: { mode: 'update', apply: ['formats', 'subjects'] } },
			'resetCourse',
			{ step: 'search', meta: { search: { update: true }, syncNav: 'spread' } },
		],
	},

	enrollable: {
		steps: [
			{ step: 'termOptions', meta: { mode: 'update', apply: ['subjects'] } },
			{ step: 'search', meta: { search: { update: true }, syncNav: 'spread' } },
		],
	},

	format: {
		steps: [
			{ step: 'courses', meta: { mode: 'update' } },
			{ step: 'search', meta: { search: { update: true }, syncNav: 'spread' } },
		],
	},

	subject: {
		steps: [
			{ step: 'courses', meta: { mode: 'update' } },
			{ step: 'search', meta: { search: { update: true }, syncNav: 'spread' } },
		],
	},

	days: {
		steps: [
			{ step: 'search', meta: { search: { update: true }, syncNav: 'spread' } },
		],
	},

	course: {
		steps: [
			{ step: 'search', meta: { search: { update: true }, syncNav: 'spread' } },
		],
	},

	startsOn: {
		steps: [
			{ step: 'search', meta: { search: { update: true }, syncNav: 'spread' } },
		],
	},

	paginate: {
		steps: [
			{ step: 'searchPage', meta: { syncNav: 'spread' } },
		],
	},

	categoryNav: {
		steps: [
			{ step: 'searchPage', meta: { syncNav: 'category' } },
		],
	},
};
